import * as React from "react";
import Query from "./query";
import MethodDesktop from "./MethodDesktop/MethodDesktop";
import MethodMobile from "./MethodMobile/MethodMobile";
import { useEffect, useState } from "react";
import { filterDataByLanguage } from "../../Utils/Language";
import PropTypes from "prop-types";

const isBrowser = typeof window !== "undefined";

const Method = (props) => {
  const [width, setWidth] = useState(0);
  const data = Query();
  const methodData = filterDataByLanguage(props.lang, data.allContentfulMetodo);

  useEffect(() => {
    if (isBrowser) {
      setWidth(window.innerWidth);
    }
  });

  return (
    <>
      {width >= 810 && <MethodDesktop data={methodData} lang={props.lang} />}
      {width < 810 && <MethodMobile data={methodData} />}
    </>
  );
};

Method.propTypes = {
  lang: PropTypes.string.isRequired,
};

export default Method;
